import { queryConfig } from './queryConfig';

export interface ProgramDetail {
  uid: string;
  name: string;
  tag_line: string;
  starts_at: string;
  ends_at: string;
  active: boolean;
  access_models: string[];
  revenue_share: number;
  fee: number;
}

export interface ProgramSummary {
  sales: string;
  vendor_earnings: string;
  net_revenue: string;
  members_balance: string;
}

export interface ProgramMember {
  uid: string;
  name: string;
  email: string;
  phone: string;
  spend: string;
  balance: string;
  onboarded: boolean;
  active: boolean;
}

export interface ProgramTerminal {
  uid: string;
  merchant_name: string;
}

const query = queryConfig({});

export const useGetProgramDetail = (uid: string) =>
  query<{ program: ProgramDetail }>({
    url: `/v1/programs/${uid}/details`,
    cacheKey: `program-detail-${uid}`,
    enabled: uid !== '',
  });

export const useGetProgramSummary = (uid: string) =>
  query<{ summary: ProgramSummary }>({
    url: `/v1/programs/${uid}/summary`,
    cacheKey: `program-summary-${uid}`,
    enabled: uid !== '',
  });

export const useGetProgramMembers = (uid: string, params?: { page?: number; limit?: number }) =>
  query<{ members: ProgramMember[]; total: number }>({
    url: `/v1/programs/${uid}/members`,
    cacheKey: `program-members-${uid}`,
    params,
    enabled: uid !== '',
  });

export const useGetProgramTerminals = (uid: string) =>
  query<{ terminals: ProgramTerminal[] }>({
    url: `/v1/ops/programs/${uid}/terminals`,
    cacheKey: `program-terminals-${uid}`,
    enabled: uid !== '',
  });
